<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen">

        <Modal
            :text="modalText"
            id="modal_show"
        />

        <div class="bg-white rounded shadow mt-3">
            <div class="container grid grid-cols-12 gap-3 py-4">

                <div class="col-span-12 lg:col-span-4 relative">
                    <img src="/images/search-interface-symbol.png" alt="" class="h-6 absolute left-2 top-2">
                    <b-form-input
                        class="border-gray-300 pl-10 w-full h-11 focus:ring-0"
                        v-model="search.productName"
                        :placeholder="$t('sale.product.title')"
                        @input="monthlyStat"
                    />
                </div>

                <div class="col-span-2">

                </div>

                <div class="col-span-12 sm:col-span-3 lg:col-span-6">
                    <div class="flex gap-3">
                        <b-form-select
                            class="h-11 border-gray-300 focus:ring-0"
                            v-model="selectedYear"
                            @change="monthlyStat"
                            :options="optionsYear">
                        </b-form-select>
                        <b-form-select
                            class="h-11 border-gray-300 focus:ring-0"
                            v-model="selectedMonth"
                            :options="optionsMonth"
                            @change="monthlyStat">
                        </b-form-select>
                    </div>
                </div>
            </div>

            <div v-if="getProductDynamics.length" class="table-wrapper">
                <table class="">
                    <thead class="bg-lightGray h-11">
                    <tr class="font-bold text-center">
                        <td class="sticky bg-gray-100 left-0">{{ $t('product.name') }}</td>
                        <td v-for="(item, index) of getProductDays" :key="index" class="w-20 long">
                            {{ getDayAndMonth(item) }}
                        </td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) of getProductDynamics" :key="index" class="h-12 border border-b">
                        <td class="py-3 pl-3 font-bold sticky z-50 bg-gray-200 left-0">{{ item.product.name }}</td>
                        <td v-for="(dynamicDay, i) of item.productDynamicDayDtos" :key="i" class="text-center relative long">

                            <div v-if="Number(dynamicDay.difference) > 0" class="font-bold text-green-600">
                                {{ Number(dynamicDay.soldAmount) }} {{ showUnitOfMeasure(item.product.unitOfMeasure) }}
                            </div>
                            <div v-else-if="Number(dynamicDay.difference) === 0" class="font-bold text-yellow-600">
                                {{ Number(dynamicDay.soldAmount) }} {{ showUnitOfMeasure(item.product.unitOfMeasure) }}
                            </div>
                            <div v-else class="font-bold text-red-500">
                                {{ Number(dynamicDay.soldAmount) }} {{ showUnitOfMeasure(item.product.unitOfMeasure) }}
                            </div>
                            <div v-if="Number(dynamicDay.difference) > 0" class="absolute top-0 right-1/3 text-green-600 font-bold">
                                {{ dynamicDay.difference }}
                            </div>
                            <div v-else-if="Number(dynamicDay.difference) === 0" class="absolute top-0 right-1/3 text-yellow-600 font-bold">
                                {{ Number(dynamicDay.difference) }}
                            </div>
                            <div v-else class="absolute top-0 right-1/3 text-red-500 font-bold">
                                {{ dynamicDay.difference }}
                            </div>

                            <div>
                                <img v-if="myIndex === dynamicDay['@id']" @click="findTransaction(null)"  src="/images/down-arrow-blue.png" alt="" class="h-4 absolute right-4 top-5 cursor-pointer">
                                <img v-else @click="findTransaction(dynamicDay['@id'], item.product.id, dynamicDay.date)" src="/images/right-arrow%20-blue.png" alt="" class="h-4 absolute right-4 top-5 cursor-pointer">
                            </div>

                            <div v-if="myIndex === dynamicDay['@id']" class="min-w-max min-h-full bg-gray-50 mt-3 absolute z-50 border rounded shadow -left-1/2">
                                <div>
                                    <div class="flex justify-between font-bold border-bottom h-10 items-center">
                                        <div class="pl-2">{{ $t('printView.receipt') }}</div>
                                        <div class="px-3">{{ $t('employee.cashier') }}</div>
                                        <div class="px-3">{{ $t('kpi.date.title') }}</div>
                                        <div class="px-3">{{ $t('amount') }}</div>
                                        <div class="px-3">{{ $t('sale.sum') }}</div>
                                        <div @click="findTransaction(null)" class="cursor-pointer px-3 pt-0.5">&#x2715;</div>
                                    </div>
                                    <div v-for="(saleProduct, index) of getTodaySaleProducts" :key="index" class="flex justify-between items-center h-10">
                                        <div class="w-14">{{ saleProduct.id }}</div>
                                        <div>{{ saleProduct.givenName }} {{ saleProduct.familyName.slice(0, 1) }}.</div>
                                        <div>{{ timeFormat(saleProduct.createdAt) }}</div>
                                        <div>{{ parseFloat(saleProduct.amount) }}</div>
                                        <div>{{ showCurrencyById(saleProduct.currencyId, saleProduct.price) }}</div>
                                        <div></div>
                                    </div>
                                </div>
                            </div>
                        </td>

                    </tr>
                    </tbody>
                </table>
            </div>

            <div v-else class="min-h-screen text-center text-2xl font-bold">
                {{ $t('noData') }} :(
            </div>
        </div>
    </Row>
</template>

<script>
import Row from "@/components/html/Row";
import accessMixin from "@/mixin/accessMixin";
import {mapActions, mapGetters} from "vuex";
import validatorMixin from "@/mixin/validatorMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import dateFormattingMixin from "@/mixin/dateFormattingMixin";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import Modal from "@/components/html/Modal.vue";

export default {
    name: "EmployeesList",
    components: {Modal, Row},
    mixins: [validatorMixin, accessMixin, currencyFormatMixin, dateFormattingMixin, currencyRateMixin],
    data() {
        return {
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'statistics.productDynamic'},
            ],
            search: {
                productName: '',
                after: null,
                before: null,
                page: 1,
            },
            myIndex: null,
            jsDate: "1970-01-01T",
            modalText: '',
            isLoading: false,
            url: process.env.VUE_APP_API_URL,
            selectedYear: null,
            optionsYear: [],
            selectedMonth: null,
            optionsMonth: [
                {value: {start: '01-01', end: '01-31'}, number: 0, text: this.$t('statistics.month.Jan')},
                {value: {start: '02-01', end: '02-28'}, number: 1, text: this.$t('statistics.month.Feb')},
                {value: {start: '03-01', end: '03-31'}, number: 2, text: this.$t('statistics.month.Mar')},
                {value: {start: '04-01', end: '04-30'}, number: 3, text: this.$t('statistics.month.Apr')},
                {value: {start: '05-01', end: '05-31'}, number: 4, text: this.$t('statistics.month.May')},
                {value: {start: '06-01', end: '06-30'}, number: 5, text: this.$t('statistics.month.Jun')},
                {value: {start: '07-01', end: '07-31'}, number: 6, text: this.$t('statistics.month.Jul')},
                {value: {start: '08-01', end: '08-31'}, number: 7, text: this.$t('statistics.month.Aug')},
                {value: {start: '09-01', end: '09-30'}, number: 8, text: this.$t('statistics.month.Sep')},
                {value: {start: '10-01', end: '10-31'}, number: 9, text: this.$t('statistics.month.Oct')},
                {value: {start: '11-01', end: '11-30'}, number: 10, text: this.$t('statistics.month.Nov')},
                {value: {start: '12-01', end: '12-31'}, number: 11, text: this.$t('statistics.month.Dec')},
            ],
        }
    },
    computed: {
        ...mapGetters(['getUserCompanyCreatedAt', 'getProductDynamics', 'getProductDays', 'getProductDynamicsTotalCount', 'getTodaySaleProducts'])
    },
    methods: {
        ...mapActions(['setBreadcrumbItems', 'searchProductDynamics', 'searchTodaySaleProducts']),
        findTransaction(id, productId = null, date = null) {
            if (productId) {
                this.$root.showOverlay = true

                let search = {}
                search.productId = productId
                search.after = date + 'T00:00:00'
                search.before = date + 'T23:59:59'

                this
                    .searchTodaySaleProducts(search)
                    .then(() => {
                        this.myIndex = id

                        this.$root.showOverlay = false
                    })
                    .catch((reason) => {
                        this.$root.showOverlay = false
                        this.modalText = reason
                        this.$bvModal.show('modal_show')
                    })
            } else {
                this.myIndex = id
            }
        },
        async createYear() {
            let created = parseInt(this.getUserCompanyCreatedAt)

            while (created <= new Date().getFullYear()) {
                this.optionsYear.unshift({value: created, text: created})
                created++
            }

            await this.setYear()
        },
        setYear() {
            this.selectedYear = this.optionsYear[0].value
        },
        getDayAndMonth(createdAt) {
            let date = new Date(createdAt + 'T00:00:00')
            return date.getDate() + '-' + this.optionsMonth[date.getMonth()].text
        },
        monthlyStat() {
            this.$root.showOverlay = true

            if (this.selectedYear === null && this.selectedMonth === null) {
                return
            }

            this.search.after = this.selectedYear + '-' + this.selectedMonth.start
            this.search.before = this.selectedYear + '-' + this.selectedMonth.end

            this
                .searchProductDynamics(this.search)
                .then(() => {
                    this.$root.showOverlay = false
                })
                .catch((reason) => {
                    this.$root.showOverlay = false
                    this.modalText = reason
                    this.$bvModal.show('modal_show')
                })
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.$root.showOverlay = true
        this.selectedMonth = this.optionsMonth[new Date().getMonth()].value
        this
            .fetchUser()
            .then(() => {
                this.createYear()

                this.search.after = this.selectedYear + '-' + this.selectedMonth.start
                this.search.before = this.selectedYear + '-' + this.selectedMonth.end
                this.searchProductDynamics(this.search)
                    .then(() => {
                        this.$root.showOverlay = false
                    })
                    .catch((reason) => {
                        this.$root.showOverlay = false
                        this.modalText = reason
                        this.$bvModal.show('modal_show')
                    })
            })
            .catch((reason) => {
                this.$root.showOverlay = false
                this.modalText = reason
                this.$bvModal.show('modal_show')
            })
    }
}
</script>

<style scoped>

.table-wrapper {
    width: 100%;
    overflow-x: scroll;
}

td, th {
    min-width: 180px;
}

::-webkit-scrollbar {
    height: 8px;
}

::-webkit-scrollbar-thumb {
    -webkit-border-radius: 5px;
    border-radius: 8px;
    background: #6539B2;
}

tr > :first-child {
    min-width: 250px;
}

</style>